import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	color: black;
	flex: 1;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
`;

export const ButtonWrapper = styled.div`
	margin-right: 16px;

	&:last-child {
		margin-right: 0;
	}
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 32px 0 32px 4px;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const TableWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 40px;

	${Header} {
		padding-bottom: 16px;
		margin-left: auto;
	}
`;
